define((require) => {
    "use strict";

    const Enum                  = require("shared/util/Enum");
    const Sorting               = require("ui/dashboard/Sorting");
    const SortingHelperMethods  = require("ui/dashboard/SortingHelperMethods");
    const Storage               = require("shared/services/Storage");

    const SORTING_KEY = "sorting";

    const DashboardSorting = Enum.create("DashboardSorting", "value", {

        MONTH: new Sorting("month", ["editedAt"]),

        ALPHABETICAL: new Sorting("alphabetical", [{name: "normalizedName", direction: "Ascending"}]),

        PERSON: new Sorting("person", ["createdBy", "editedAt"]),

        STATE: new Sorting("state", ["state", "editedAt"])

    }, {
        // We need to create a closure so we have access to the DashboardSorting variable.
        current: () => SortingHelperMethods.current(Storage.Keys.DASHBOARD_SORTING_PANEL, SORTING_KEY, DashboardSorting, DashboardSorting.MONTH)(),

        set: SortingHelperMethods.set(Storage.Keys.DASHBOARD_SORTING_PANEL, SORTING_KEY),

        fromValue: (value) => SortingHelperMethods.fromValue(DashboardSorting)(value)
    });

    return DashboardSorting;
});



// WEBPACK FOOTER //
// ./src/editor/ui/dashboard/DashboardSorting.js